module.exports = __webpack_public_path__ + "static/media/party-can-product-01.9b84b23a.png";